// This file contains the functions to process a data set (such as that in Ag-Grid)
// based on the query built in QueryBuilder.
const filter = (row, field, operator, value) => {
  switch (operator) {
    case "=":
      return row[field] && row[field] == value; // FIXME: matching number to string
    case "!=":
      return row[field] && row[field] != value;
    case "<":
      return row[field] && row[field] < value;
    case ">":
      return row[field] && row[field] > value;
    case "<=":
      return row[field] && row[field] <= value;
    case ">=":
      return row[field] && row[field] >= value;
    case "contains":
      return (
        row[field] && row[field].toLowerCase().indexOf(value.toLowerCase()) >= 0
      );
    case "beginsWith":
      return (
        row[field] &&
        row[field].toLowerCase().indexOf(value.toLowerCase()) === 0
      );
    case "endsWith":
      return (
        row[field] &&
        row[field].toLowerCase().indexOf(value.toLowerCase()) ===
          row[field].length - value.length
      );
    case "doesNotContain":
      return (
        row[field] || row[field].toLowerCase().indexOf(value.toLowerCase()) < 0
      );
    case "doesNotBeginWith":
      return (
        row[field] ||
        row[field].toLowerCase().indexOf(value.toLowerCase()) !== 0
      );
    case "doesNotEndWith":
      return (
        row[field] ||
        row[field].toLowerCase().indexOf(value.toLowerCase()) !==
          row[field].length - value.length
      );
    case "null":
      return !row[field];
    case "notNull":
      return row[field];
    default:
      return false;
  }
};

const predicateSingle = (row, query) => {
  return filter(row, query.field, query.operator, query.value);
};

const predicate = (row, query, combinator) => {
  let rules = [];
  if (Array.isArray(query)) {
    rules = query;
  } else if (Array.isArray(query.rules)) {
    return predicate(row, query.rules, query.combinator);
  } else {
    return predicateSingle(row, query);
  }

  let result = true;

  for (let ruleIndex = 0; ruleIndex < rules.length; ruleIndex++) {
    const rule = rules[ruleIndex];
    if (ruleIndex === 0) {
      result = predicate(row, rule, combinator);
    } else if (combinator.toLowerCase() === "and") {
      result = result && predicate(row, rule, combinator);
    } else if (combinator.toLowerCase() === "or") {
      result = result || predicate(row, rule, combinator);
    }
  }

  return result;
};

function simpleResultProcessing(data, query) {
  const newData = [];

  for (let rowIndex = 0; rowIndex < data.length; rowIndex++) {
    const row = data[rowIndex];
    const show = predicate(row, query.rules, query.combinator);
    if (show) {
      newData.push(row);
    }
  }

  return newData;
}

export { simpleResultProcessing };
